import { render, staticRenderFns } from "./LegalView.vue?vue&type=template&id=5a3eb0fd&scoped=true&"
import script from "./LegalView.vue?vue&type=script&lang=js&"
export * from "./LegalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3eb0fd",
  null
  
)

export default component.exports